import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { FileText } from 'lucide-react';

const TermsOfServicePage = () => {
  return (
    <div className="page legal-page">
      <Header onEnrollClick={() => window.location.href = '/pricing'} />
      
      <main className="page-content">
        <section className="page-hero legal-hero">
          <div className="container">
            <FileText className="legal-icon" />
            <h1 className="page-title">Terms of Service</h1>
            <p className="page-subtitle">Last updated: January 2026</p>
          </div>
        </section>

        <section className="legal-content">
          <div className="container">
            <div className="legal-document">
              <h2>1. Agreement to Terms</h2>
              <p>
                By accessing or using WSafe AI ML's website and services, you agree to be bound by these 
                Terms of Service. If you do not agree to these terms, please do not use our services.
              </p>

              <h2>2. Description of Services</h2>
              <p>
                WSafe AI ML provides online educational content, courses, and resources focused on 
                artificial intelligence and machine learning. Our services include:
              </p>
              <ul>
                <li>Video lectures and tutorials</li>
                <li>Hands-on projects and assignments</li>
                <li>Community forums and discussions</li>
                <li>Certificates of completion</li>
                <li>Career support services (Premium plans)</li>
              </ul>

              <h2>3. Account Registration</h2>
              <p>To access our courses, you must:</p>
              <ul>
                <li>Create an account with accurate information</li>
                <li>Be at least 16 years of age</li>
                <li>Maintain the security of your account credentials</li>
                <li>Notify us immediately of any unauthorized access</li>
              </ul>

              <h2>4. Payment and Refunds</h2>
              <h3>4.1 Payment</h3>
              <p>
                Course fees are charged at the time of purchase. We accept major credit cards and 
                other payment methods as displayed during checkout.
              </p>
              <h3>4.2 Refund Policy</h3>
              <p>
                We offer a 30-day money-back guarantee. See our <a href="/refund-policy">Refund Policy</a> for details.
              </p>

              <h2>5. Intellectual Property</h2>
              <p>
                All content on WSafe AI ML, including but not limited to text, graphics, logos, videos, 
                and course materials, is the property of WSafe AI ML and is protected by copyright laws.
              </p>
              <h3>5.1 License to Use</h3>
              <p>
                Upon purchase, you are granted a limited, non-exclusive, non-transferable license to 
                access and view the course content for personal, non-commercial purposes.
              </p>
              <h3>5.2 Restrictions</h3>
              <p>You may not:</p>
              <ul>
                <li>Copy, reproduce, or distribute course materials</li>
                <li>Share your account or login credentials</li>
                <li>Use content for commercial purposes without permission</li>
                <li>Reverse engineer or attempt to extract source code</li>
              </ul>

              <h2>6. User Conduct</h2>
              <p>When using our services, you agree not to:</p>
              <ul>
                <li>Violate any applicable laws or regulations</li>
                <li>Infringe on the rights of others</li>
                <li>Post harmful, offensive, or inappropriate content</li>
                <li>Attempt to gain unauthorized access to our systems</li>
                <li>Interfere with the proper functioning of the platform</li>
              </ul>

              <h2>7. Certificates</h2>
              <p>
                Certificates are issued upon successful completion of course requirements. Certificates 
                represent completion of our curriculum and are not academic degrees or professional licenses.
              </p>

              <h2>8. Disclaimer of Warranties</h2>
              <p>
                Our services are provided "as is" without warranties of any kind, either express or implied. 
                We do not guarantee specific outcomes, job placement, or salary increases.
              </p>

              <h2>9. Limitation of Liability</h2>
              <p>
                To the maximum extent permitted by law, WSafe AI ML shall not be liable for any indirect, 
                incidental, special, consequential, or punitive damages arising from your use of our services.
              </p>

              <h2>10. Modifications to Terms</h2>
              <p>
                We reserve the right to modify these terms at any time. Continued use of our services 
                after changes constitutes acceptance of the modified terms.
              </p>

              <h2>11. Termination</h2>
              <p>
                We may terminate or suspend your account and access to our services at our sole discretion, 
                without notice, for conduct that we believe violates these Terms or is harmful to other users.
              </p>

              <h2>12. Governing Law</h2>
              <p>
                These Terms shall be governed by and construed in accordance with the laws of the 
                United States, without regard to its conflict of law provisions.
              </p>

              <h2>13. Contact Information</h2>
              <p>
                For questions about these Terms, please contact us at:
              </p>
              <ul>
                <li>Email: legal@wsafeaiml.com</li>
                <li>Contact Form: <a href="/contact">Contact Page</a></li>
              </ul>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default TermsOfServicePage;
